import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import TechImg1 from '../../assest/Tech-1.webp';
import TechImg2 from '../../assest/Tech-2.png';
import TechImg3 from '../../assest/Tech-3.png';

const techniciansList = [
  {
    name: "Maintenance Technician",
    image: TechImg1,
    specs: "Routine checks and repairs for equipment and facilities.",
    description: "Handles regular maintenance tasks to keep systems and machinery running smoothly.",
  },
  {
    name: "Field Service Technician",
    image: TechImg2,
    specs: "On-site technical support and installations.",
    description: "Travels to client locations to diagnose, repair, or install technical equipment.",
  },
  {
    name: "Mechanical Technician",
    image: TechImg3,
    specs: "Mechanical system setup and troubleshooting.",
    description: "Experienced in assembling, testing, and maintaining mechanical devices and systems.",
  },
];

const translations = {
  gb: {
    heading: "Technician Services",
    introText: "Qualified technicians available for all types of mechanical and technical services.",
    categoriesTitle: "Available Services",
    featuredTitle: "Top Technicians",
    featuredDescription: "Our skilled technicians are equipped to handle complex systems with precision.",
  },
  sa: {
    heading: "خدمات الفنيين",
    introText: "فنيون مؤهلون متاحون لجميع أنواع الخدمات الميكانيكية والتقنية.",
    categoriesTitle: "الخدمات المتاحة",
    featuredTitle: "أفضل الفنيين",
    featuredDescription: "فنيونا المهرة مجهزون للتعامل مع الأنظمة المعقدة بدقة وكفاءة.",
  },
};

const Technicians = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={techniciansList}
      language={language}
    />
  );
};

export default Technicians;
